import { configureStore, AnyAction } from '@reduxjs/toolkit'
import { createEpicMiddleware } from 'redux-observable'
import { persistStore, persistReducer, PersistConfig } from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'

import rootEpic from './root.epics'
import rootReducer, { RootState } from './root.reducer'

import AppDeps from '../model/AppDeps'

export default function createAppStore(appDeps: AppDeps, preloadedState: RootState | undefined) {
  const epicMiddleware = createEpicMiddleware<AnyAction, AnyAction, RootState, AppDeps>({
    dependencies: appDeps,
  })

  const persistConfig: PersistConfig<RootState, RootState, RootState, RootState> = {
    key: 'root',
    keyPrefix: `${appDeps.buildtimeConfig.REACT_APP_VERSION}_`,
    storage,
    whitelist: [],
    stateReconciler: autoMergeLevel2,
  }

  const persistedReducer = persistReducer<RootState, AnyAction>(persistConfig, rootReducer)

  const store = configureStore({
    reducer: persistedReducer,
    preloadedState,
    middleware: [epicMiddleware],
  })

  epicMiddleware.run(rootEpic)

  const persistor = persistStore(store)

  return { store: (store as unknown) as RootState, persistor }
}
